import React, { useEffect, useState } from 'react'

function LiveTime({ formatOptions }) {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, [])
    return (
        <>{time.toLocaleString('en-US', formatOptions)}</>
    )
}

export default LiveTime